import { useEffect, useRef } from 'react';

const useOutsideClick = (onOutsideClick) => {
  const ref = useRef();

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onOutsideClick();
      }
    };

    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [onOutsideClick]);

  return ref;
};

export default useOutsideClick;